import React from "react";

const Spinner = ({ color }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", width: "100%", backgroundColor: color ? color : "rgba(15, 15, 15,0.5)", position: "fixed", zIndex: 1500 }}>
      <div className="fa-3x">
        <i style={{ color: "#1D454C" }} className="fas fa-solid fa-spinner fa-spin-pulse"></i>
      </div>
    </div>
  );
};

export default Spinner;
